import { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import toast, { Toaster } from "react-hot-toast";
import { useFadeIn } from "../../hooks/useFadeIn";
import { SectionHeader } from "../layout/SectionHeader";

type SendState = "idle" | "sending" | "sent";

export const Contact = () => {
  const ref = useFadeIn<HTMLElement>();
  const formRef = useRef<HTMLFormElement>(null);
  const resetTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [send, setSend] = useState<SendState>("idle");

  useEffect(() => () => {
    if (resetTimer.current) clearTimeout(resetTimer.current);
  }, []);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || send !== "idle") return;
    setSend("sending");
    emailjs
      .sendForm(
        "service_v2swzbh",
        "template_rcz3g9r",
        formRef.current!,
        "hhdRW3rc1RE2CP7iz"
      )
      .then(() => {
        setSend("sent");
        toast.success("message sent");
        setName(""); setEmail(""); setMessage("");
        resetTimer.current = setTimeout(() => setSend("idle"), 2400);
      })
      .catch((err) => {
        console.error("[Contact] EmailJS error:", err);
        setSend("idle");
        toast.error("send failed");
      });
  };

  const status =
    send === "sending"
      ? { dotClass: "dot--amber", text: "dispatching message..." }
      : send === "sent"
      ? { dotClass: "dot--green", text: "message sent" }
      : { dotClass: "dot--green", text: "ready to send · encrypted in transit" };

  return (
    <section ref={ref} className="contact reveal" id="contact">
      <Toaster />
      <div className="container">
        <SectionHeader num="06" command="> ./contact.sh" caption="initiate handshake" />

        <div className="contact__panel">
          <div className="contact__grid">
            <div className="contact__intro">
              <div className="contact__ssh">
                <span className="green">$</span> ssh suman@pokharel.dev
              </div>
              <h2 className="contact__headline">
                Let's <span className="ac">build</span> something.
              </h2>
              <p className="contact__tagline">
                Open inbox, fast replies (usually within 24 hours). Up for full-time,
                freelance, or a coffee chat.
              </p>
              <div className="contact__list">
                <div className="contact__listHead">{"// "}or reach me directly</div>
                <ul>
                  <li><span className="k">email</span> <span className="sep">·</span> sumanpok9@gmail.com</li>
                  <li><span className="k">github</span> <span className="sep">·</span> @iamsumanp</li>
                  <li><span className="k">twitter</span> <span className="sep">·</span> @sumanp_dev</li>
                </ul>
              </div>
            </div>

            <form ref={formRef} className="form" onSubmit={onSubmit} noValidate>
              <div className="form__head">
                <span className="green">$</span> CAT ./WORKING-TOGETHER.FORM
              </div>

              <div className="form__row form__row--two">
                <label className="field">
                  <span className="field__label"><span className="ac">&gt;</span> NAME</span>
                  <input
                    name="user_name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoComplete="name"
                  />
                </label>
                <label className="field">
                  <span className="field__label"><span className="ac">&gt;</span> EMAIL</span>
                  <input
                    type="email"
                    name="user_email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                  />
                </label>
              </div>

              <label className="field field--full">
                <span className="field__label">
                  <span className="ac">&gt;</span> MESSAGE
                  <span className="optional"> {"// "}optional</span>
                </span>
                <textarea
                  name="message"
                  rows={5}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </label>

              <div className="form__submit">
                <span className="form__status">
                  <span className={`dot ${status.dotClass}`} aria-hidden="true" /> {status.text}
                </span>
                <button
                  type="submit"
                  className={`btn btn--primary ${send === "sent" ? "is-sent" : ""}`}
                  disabled={send !== "idle"}
                >
                  {send === "sent" ? "✓ message sent" : "./submit.sh →"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
